<template>
    <el-main>
        <div class="breadcrumb-container">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item>Settings</el-breadcrumb-item>
                <el-breadcrumb-item>System Preference</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <el-row style="margin-top: 24px">
            <el-col :span="16">
                <div class="main-title" >
                    System Preference
                </div>

            </el-col>
            <el-col :span="8" class="text-right">
                <el-button type="success" size="small" @click="savePref" v-loading="saving">Save Preference</el-button>
                <el-button type="default" size="small" @click="showTestDialog = true" v-loading="saving">Test Email</el-button>
            </el-col>
        </el-row>
        <el-row type="flex" style="margin-top: 24px" align="top">
            <el-col :span="24">
                
                    <el-form ref="form" :model="form"  status-icon >
                    
                        <el-card class="box-card mb-4" v-loading="saving">
                            <div slot="header" class="clearfix">
                                <span>Email Preference</span>
                            </div>
                            <div  class="text item">
                                <el-row type="flex" class="row-bg" justify="center" >
                                    <el-col :lg="16" :md="20" :sm="24">
                                        <el-form-item label="Email Host" prop="host" label-width="200px">
                                            <el-input type="text" v-model="form.host"></el-input>
                                        </el-form-item>
                                        <el-form-item label="Email Port" prop="port" label-width="200px">
                                            <el-input type="number" v-model="form.port"></el-input>
                                        </el-form-item>
                                        <el-form-item label="Email Username" prop="username" label-width="200px">
                                            <el-input type="text" v-model="form.username"></el-input>
                                        </el-form-item>
                                        <el-form-item label="Email Password" prop="password" label-width="200px">
                                            <el-input type="text" v-model="form.password"></el-input>
                                        </el-form-item>
                                        <el-form-item label="Email From" prop="from" label-width="200px">
                                            <el-input type="text" v-model="form.from"></el-input>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                            </div>
                        </el-card>
                    </el-form>
            </el-col>
        </el-row>
        <el-dialog title="Test Email" :visible.sync="showTestDialog">
            <el-form :model="emailForm" ref="dataForm" :rules="rules" v-loading="sendingEmail">
                <el-form-item :required="true" label="Email" :label-width="formLabelWidth" prop="email">
                    <el-input v-model="emailForm.email"></el-input>
                </el-form-item>
                
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button size="small" @click="showTestDialog = false">Cancel</el-button>
                <el-button size="small" type="primary" @click="sendTestEmail()">Send</el-button>
            </span>
        </el-dialog>
    </el-main>
</template>

<script>
import api from '@/services/api/WRCService'
import _ from 'lodash'

export default {
    props: ['roleId'],
    data: function() {
        return {
            loading: false,
            saving: false,
            showTestDialog: false,
            sendingEmail: false,
            preference: {},
            formLabelWidth: '120px',
            form: {
                host: '',
                port: '',
                username: '',
                password: '',
                from: '',
            },
            emailForm: {
                email: '',
            }
        }
    },
    computed: {
        rules() {
            return {
                email: [
                    {required: true, message: 'Please enter email', trigger: 'blur'}
                ],
            }
        },
    },
    methods: {
        savePref() {
            
            let params = {
                emailHost: this.form.host,
                emailPort: this.form.port,
                emailUsername: this.form.username,
                emailPassword: this.form.password,
                emailFrom: this.form.from,
            }

            this.saving = true

            api.savePreferences(params).then(() => {
                this.$message({
                    message: 'Successfully Saved Preferences.',
                    type: 'success'
                });
            }).catch((error) => {
                this.$message({
                    message: 'Server error: ' + error.response.status + '.',
                    type: 'error'
                });
            }).then(() => {
                this.saving = false;
            });
        },
        sendTestEmail() {
            let params = {
                email: this.emailForm.email,
            }

            this.sendingEmail = true

            api.sendTestEmail(params).then(() => {
                this.$message({
                    message: 'Successfully Sent Email.',
                    type: 'success'
                });

                this.showTestDialog = false
            }).catch((error) => {
                this.$message({
                    message: 'Server error: ' + error.response.status + '.',
                    type: 'error'
                });
            }).then(() => {
                this.sendingEmail = false
            });
        }
    },
    mounted() {
        

            this.saving = true
            api.getPreferences().then(({data}) => {
                this.preference = data.data
                this.form.host = this.preference.emailHost
                this.form.port = this.preference.emailPort
                this.form.username = this.preference.emailUsername
                this.form.from = this.preference.emailFrom
            }).catch(() => {}).then(() => {
                this.saving = false
            })
    }
}
</script>

<style scoped>
    .el-col.section-col{
        margin-bottom: 20px
    }

    .privilege-holder {
        position: relative;
        padding: 7px;
        font-size: 14px;
    }

    .privilege-switch {
        position: absolute;
    }

    .privilege-detail {
        margin-left: 65px;
        min-height: 70px;
    }

    .privilege-description {
        margin-top: 7px;
        color: #a7a7a7;
    }
</style>